import {AbstractVisualFeature, allVisuals} from '../visual-feature.js';

import PALETTE_SCHEMA from './cards-and-promotions.palette-schema.yaml';

class CardsAndBannersFeature extends AbstractVisualFeature {
    get name() {
        return 'CardsAndBanners';
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getSerializableVisualConfig() {
        return {};
    }
}

export const CardsAndPromotions = new CardsAndBannersFeature(allVisuals);
